import { defineMessages } from 'react-intl';

const baseId = 't.Validation.Error.';

export default defineMessages({
    required: {
        id: `${baseId}required`,
        defaultMessage: 'This field is required.',
    },
});